module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesNatural@2x.4e5aa5c.webp";